import { Dexie } from 'dexie';
import axios from 'axios';

class TalismanTokenRatesDatabase extends Dexie {
  constructor() {
    super("TalismanTokenRates");

    // https://dexie.org/docs/Tutorial/Design#database-versioning
    this.version(1).stores({
      // You only need to specify properties that you wish to index.
      // The object store will allow any properties on your stored objects but you can only query them by indexed properties
      // https://dexie.org/docs/API-Reference#declare-database
      //
      // Never index properties containing images, movies or large (huge) strings. Store them in IndexedDB, yes! but just don’t index them!
      // https://dexie.org/docs/Version/Version.stores()#warning
      tokenRates: "tokenId"
    });

    // this.on("ready", async () => {})
  }
}

const db = new TalismanTokenRatesDatabase();

const NewTokenRates = () => ({
  usd: null,
  aud: null,
  nzd: null,
  cud: null,
  hkd: null,
  eur: null,
  gbp: null,
  jpy: null,
  krw: null,
  cny: null,
  btc: null,
  eth: null,
  dot: null
});

// the base url of the v3 coingecko api
const coingeckoApiUrl = "https://api.coingecko.com/api/v3";

// every currency in this list will be fetched from coingecko
// comment out unused currencies to save some bandwidth!
const coingeckoCurrencies = ["usd",
// 'aud',
// 'nzd',
// 'cud',
// 'hkd',
"eur"
// 'gbp',
// 'jpy',
// 'krw',
// 'cny',
// 'btc',
// 'eth',
// 'dot',
];

// export function tokenRates(tokens: WithCoingeckoId[]): TokenRatesList {}
async function fetchTokenRates(tokens) {
  // create a map from `coingeckoId` -> `tokenId` for each token
  const coingeckoIdToTokenIds = Object.values(tokens)
  // ignore testnet tokens
  .filter(({
    isTestnet
  }) => !isTestnet)

  // ignore tokens which don't have a coingeckoId
  .filter(hasCoingeckoId)

  // get each token's coingeckoId
  .reduce((coingeckoIdToTokenIds, {
    id,
    coingeckoId
  }) => {
    if (!coingeckoIdToTokenIds[coingeckoId]) coingeckoIdToTokenIds[coingeckoId] = [];
    coingeckoIdToTokenIds[coingeckoId].push(id);
    return coingeckoIdToTokenIds;
  }, {});

  // create a list of coingeckoIds we want to fetch
  const coingeckoIds = Object.keys(coingeckoIdToTokenIds);

  // skip network request if there is nothing for us to fetch
  if (coingeckoIds.length < 1) return {};

  // construct a coingecko request
  const idsSerialized = coingeckoIds.join(",");
  const currenciesSerialized = coingeckoCurrencies.join(",");
  const queryUrl = `${coingeckoApiUrl}/simple/price?ids=${idsSerialized}&vs_currencies=${currenciesSerialized}`;

  // fetch the token prices from coingecko
  // the response should be in the format:
  // {
  //   [coingeckoId]: {
  //     [currency]: rate
  //   }
  // }
  const coingeckoPrices = await axios.get(queryUrl).then(response => response.data);

  // build a TokenRatesList from the token prices result
  const ratesList = Object.fromEntries(coingeckoIds.flatMap(coingeckoId => {
    const tokenIds = coingeckoIdToTokenIds[coingeckoId];
    const rates = NewTokenRates();
    for (const currency of coingeckoCurrencies) {
      rates[currency] = ((coingeckoPrices || {})[coingeckoId] || {})[currency] || null;
    }
    return tokenIds.map(tokenId => [tokenId, rates]);
  }));

  // return the TokenRatesList
  return ratesList;
}
function hasCoingeckoId(token) {
  return "coingeckoId" in token && typeof token.coingeckoId === "string";
}

export { NewTokenRates, TalismanTokenRatesDatabase, db, fetchTokenRates, hasCoingeckoId };
